import React from 'react';

const notFound = () => {
    return (
        <div>
            <h1 style={{color:'red'}}>Page not Found</h1>
        </div>
    );
};

export default notFound;